import { useLocation, Link } from "@tanstack/react-router";
import { useEffect } from "react";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import ScheduleDialog from "@/components/ScheduleDialog";
import { ScheduleProvider, useSchedule } from "@/hooks/use-schedule";
import { Home, BookOpen, MessageCircle, Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";

const linksUteis = [
  { to: "/", label: "Página inicial", icon: Home },
  { to: "/blog", label: "Blog", icon: BookOpen },
  { to: "/nutricionista-brasileira-na-australia", label: "Serviços", icon: Calendar },
  { to: "/contato", label: "Contato", icon: MessageCircle },
];

const PageContent = () => {
  const location = useLocation();
  const { open, setOpen } = useSchedule();

  useEffect(() => {
    document.title = "Página não encontrada | Clara Camille";
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <>

      <div className="min-h-screen flex flex-col">
        <Navigation />

        <main className="flex-1 flex items-center justify-center py-24 sm:py-32">
          <div className="container mx-auto px-4 sm:px-6 max-w-2xl text-center space-y-8">
            <div className="space-y-4">
              <p className="text-8xl sm:text-9xl font-typewriter font-bold gradient-text opacity-60">404</p>
              <h1 className="text-2xl sm:text-4xl font-typewriter font-bold text-foreground">
                Página não encontrada
              </h1>
              <p className="text-base sm:text-lg text-muted-foreground font-sans leading-relaxed">
                A página que você procura não existe ou foi movida. Que tal explorar uma dessas opções?
              </p>
            </div>

            <div className="grid grid-cols-2 gap-3 sm:gap-4 max-w-md mx-auto">
              {linksUteis.map((link) => {
                const Icon = link.icon;
                return (
                  <Link
                    key={link.to}
                    to={link.to}
                    className="flex items-center gap-2.5 p-4 rounded-xl bg-primary/5 hover:bg-primary/10 transition-colors text-sm sm:text-base font-medium text-foreground font-sans"
                  >
                    <Icon className="w-4 h-4 text-primary flex-shrink-0" strokeWidth={1.5} />
                    {link.label}
                  </Link>
                );
              })}
            </div>

            <Button
              variant="gradient"
              className="rounded-full text-base px-6 py-5"
              style={{ background: 'var(--gradient-green)' }}
              asChild
            >
              <Link to="/">
                <Home className="mr-2 h-4 w-4" />
                Voltar à página inicial
              </Link>
            </Button>
          </div>
        </main>

        <Footer />
        <ScheduleDialog open={open} onOpenChange={setOpen} />
      </div>
    </>
  );
};

const NotFound = () => (
  <ScheduleProvider>
    <PageContent />
  </ScheduleProvider>
);

export default NotFound;
